module.exports = __webpack_public_path__ + "ff754a33d53402c4661515c94370dec7.svg";